export const state = {
  isLoading: false,
  isOn: true,
  isFocus: false,
  modalAlertComponents: [],
  modalComponents: [],
  keywords: [],
  routeLayout: {
    isHeader: false,
    titleName: '',
    isBack: false,
    isLike: false,
    isExcel: false,
    isNav: false,
    isHome: true,
    isSearch: false,
    isGlass: false,
    isSearchHeader: false,
    isFilter: false,
    isShare: false,
    isFuneralShare: false,
    isFuneralKakaoShare: false,
    isAnnouncementShare: false,
    isAnnouncementKakaoShare: false,
    isBusinessKakaoShare: false,
    isBusinessShare: false,
    isBizDetailShare: false,
    isBusinessMarketingKakaoShare: false,
    isBusinessMarketingShare: false,
    isBusinessDonationKakaoShare: false,
    isBusinessDonationShare: false,
    isBusinessJobKakaoShare: false,
    isBusinessJobShare: false,
    isBusinessLike: false,
    isBusinessSubscribe: false,
    isMemorialShare: false,
    isMemorialKakaoShare: false,
    // Smile
    isSmileShare: false,
    isSmileKakaoShare: false,
    isInvitationShare: false,
    isInvitationKakaoShare: false,
    subName: '',
    isBell: false,
    isSetting: false,
    isFooter: false,
    isPlus: false,
    isEdit: false,
    isDelete: false,
    isGreen: false,

    isAnnouncement: false
  },
  scroll: [],
  initMovePath: '',
  keepAlive: [],
  bottomSheet: null,
  isFloating: false,
  isHamburger: false,
  isWellFloating: false,
  productBuyMove: false,
  loginMovePath: '',
  isBackFromSearch: false,
  isTodayExpireDate: '',
  isIntroEnter: false,
  formDirty: false,
  // 260609 리뉴얼: 메인 소비자/사업자 모드 토글 상태. localStorage 영속(마지막 선택 유지).
  // 기본 'business' — 1차 확정 시안(사업자 메인)이 디폴트. 토글로 'consumer' 전환.
  homeMode: (() => {
    try { return localStorage.getItem('homeMode') || 'business'; } catch (e) { return 'business'; }
  })()
};
export default state;
